/* eslint-disable no-case-declarations */
import { PERIMETER_MODE } from 'utils/__enums/Common/Screen'
import {
  UserType,
  OrganizationType,
  ContractType,
  AllRolesType,
  UiType,
  UserInCreationType,
  CreateModifyUserType,
  SignUpUserType,
  OrganizationValidationType,
  ContractValidationType,
  ImpersonnationType,
  ApiCallBlockType,
  ContractPerimeterType,
  ServiceType,
  EceCategoryType,
  EceMotifType,
} from './state'
import { APP_ACTIONS, ActionTypes } from './actions'

// user
export const userReducer = (state: UserType, action: APP_ACTIONS) => {
  switch (action.type) {
    case ActionTypes.SET_USER_TYPE:
      return {
        ...state,
        isInternal: action.payload.isInternal,
        email: action.payload.email,
        byPassRecaptch: action.payload.byPassRecaptch,
      }
    case ActionTypes.SET_TOKEN_INFO:
      return {
        ...state,
        email: action.payload.username,
        userId: action.payload.userId,
        isInternal: action.payload.isInternal,
        organizations: action.payload.organizations,
        firstname: action.payload.firstname,
        roleNames: action.payload.roleNames,
        accessDemands: action.payload.accessDemands,
        accessDocs: action.payload.accessDocs,
        idContactWdh: action.payload.idContactWdh,
        isSuperAdminTech: action.payload.isSuperAdminTech,
        service: action.payload.service,
      }
    case ActionTypes.SET_FIRSTNAME:
      return { ...state, firstname: action.payload.firstname }
    case ActionTypes.SET_USER_SERVICE:
      return { ...state, service: action.payload.service }
    default:
      return state
  }
}

// UserInCreation
export const UserInCreationReducer = (
  state: UserInCreationType,
  action: APP_ACTIONS
) => {
  return action.type === ActionTypes.SET_CREATE_USERID
    ? { ...state, userId: action.payload.userId }
    : state
}

// createModifyUser
export const createModifyUserReducer = (
  state: CreateModifyUserType,
  action: APP_ACTIONS
) => {
  switch (action.type) {
    case ActionTypes.SET_IS_CREATION:
      return { ...state, isCreation: action.payload.isCreation }
    case ActionTypes.SET_STEP2_STATE:
      return { ...state, step2Disabled: action.payload.step2Disabled }
    case ActionTypes.SET_STEP3_STATE:
      return { ...state, step3Disabled: action.payload.step3Disabled }
    case ActionTypes.SET_USERID_CREATEMODIFY:
      return { ...state, userId: action.payload.userId }
    case ActionTypes.SET_ACTUAL_STEP:
      return { ...state, actualStep: action.payload.actualStep }
    case ActionTypes.SET_USER_ENTITY:
      return { ...state, userEntity: action.payload.userEntity }
    default:
      return state
  }
}
// user sign up
export const signUpUserReducer = (
  state: SignUpUserType,
  action: APP_ACTIONS
) => {
  switch (action.type) {
    case ActionTypes.SET_INSC_STEP2_STATE:
      return { ...state, step2Disabled: action.payload.step2Disabled }
    case ActionTypes.SET_INSC_STEP3_STATE:
      return { ...state, step3Disabled: action.payload.step3Disabled }
    case ActionTypes.SET_INSC_ACTUAL_STEP:
      return { ...state, actualStep: action.payload.actualStep }
    default:
      return state
  }
}

// impersonnation
export const impersonnationReducer = (
  state: ImpersonnationType,
  action: APP_ACTIONS
) => {
  switch (action.type) {
    case ActionTypes.SET_IS_IMPERSONNATION:
      return { ...state, isImpersonnation: action.payload.isImpersonnation }
    case ActionTypes.SET_USERNAME_IMPERSONNATION:
      return {
        ...state,
        nameImpersonnated: action.payload.nameImpersonnated,
        accessDemands: action.payload.accessDemands,
        emailImpersonated: action.payload.emailImpersonated,
      }
    default:
      return state
  }
}

// apiCallBLock
export const apiCallBlockReducer = (
  state: ApiCallBlockType,
  action: APP_ACTIONS
) => {
  return action.type === ActionTypes.SET_API_CALL_BLOCK
    ? { ...state, APICallBlocked: action.payload.APICallBlocked }
    : state
}

export const serviceReducer = (state: ServiceType, action: APP_ACTIONS) => {
  return action.type === ActionTypes.SET_SERVICE_LIST
    ? { ...state, items: [...action.payload.serviceList] }
    : state
}

// organization$
export const organizationReducer = (
  state: OrganizationType,
  action: APP_ACTIONS
) => {
  switch (action.type) {
    case ActionTypes.SET_ORGANIZATION_LIST:
      return { ...state, items: [...action.payload.organizationList] }
    case ActionTypes.RESET_PERIMETER_FILTER:
      return { ...state, items: [] }
    default:
      return state
  }
}

export const organizationValidationReducer = (
  state: OrganizationValidationType,
  action: APP_ACTIONS
) => {
  return action.type === ActionTypes.SET_ORGANIZATION_VALIDATED
    ? {
        ...state,
        organizationValidated: action.payload.organizationValidated,
      }
    : state
}
export const contractReducer = (state: ContractType, action: APP_ACTIONS) => {
  switch (action.type) {
    case ActionTypes.SET_CONTRACT_LIST:
      return { ...state, items: [...action.payload.contractList] }
    case ActionTypes.RESET_PERIMETER_FILTER:
      return { ...state, items: [] }
    case ActionTypes.SET_CONTRACT_VALIDATED:
      return {
        ...state,
        contractValidated: action.payload.contractValidated,
      }
    default:
      return state
  }
}
export const contractPerimeterReducer = (
  state: ContractPerimeterType,
  action: APP_ACTIONS
) => {
  switch (action.type) {
    case ActionTypes.SET_CONTRACT_PERIMETER:
      return {
        ...state,
        allItems: [...action.payload.contractPerimeter],
        count: action.payload.count,
      }
    case ActionTypes.SET_CONTRACT_COUNT:
      return { ...state, count: action.payload.count }
    default:
      return state
  }
}

export const contractValidationReducer = (
  state: ContractValidationType,
  action: APP_ACTIONS
) => {
  return action.type === ActionTypes.SET_CONTRACT_VALIDATED
    ? {
        ...state,
        contractValidated: action.payload.contractValidated,
      }
    : state
}

// allRoles
export const allRolesReducer = (state: AllRolesType, action: APP_ACTIONS) => {
  return action.type === ActionTypes.SET_ALL_ROLES
    ? { ...state, items: [...action.payload.allRoles] }
    : state
}

// ui
export const uiReducer = (state: UiType, action: APP_ACTIONS) => {
  switch (action.type) {
    case ActionTypes.SET_BACKGROUND_COLOR:
      return { ...state, backgroundColor: action.payload.backgroundColor }
    case ActionTypes.SWITCH_PERIMETER_FILTER_MODE:
      const { perimeterFilterMode } = state
      const newMode =
        perimeterFilterMode === PERIMETER_MODE.DECREASED_MODE
          ? PERIMETER_MODE.INCREASED_MODE
          : PERIMETER_MODE.DECREASED_MODE
      return { ...state, perimeterFilterMode: newMode }
    default:
      return state
  }
}

export const eceCategoryReducer = (
  state: EceCategoryType,
  action: APP_ACTIONS
) => {
  return action.type === ActionTypes.SET_ECE_CATEGORIES_LIST
    ? { ...state, items: [...action.payload.eceCategoryList] }
    : state
}

export const eceMotifReducer = (state: EceMotifType, action: APP_ACTIONS) => {
  return action.type === ActionTypes.SET_ECE_MOTIFS_LIST
    ? { ...state, items: [...action.payload.eceMotifList] }
    : state
}
